import { useApp } from '@/App';
import FleetTitle from '@/libs/antd/components/Title';
import { useForm } from '@/libs/antd/form';
// import { formatCurrency } from '@/libs/antd/formater';
import ANTD_DEFAULT_PROPS from '@/libs/antd/props';
import { FleetSearch } from '@/libs/fleet-api/fetcher';
import { MasterData } from '@/libs/fleet-api/services/master-data';
import {
	MonitoringPlafondSearchAgreementParam,
	useMonitoringPlafondSearchAgreement,
	useMonitoringPlafondSearchOptions,
} from '@/libs/fleet-api/services/monitoring';
import { useDownloadMPP } from '@/libs/fleet-api/services/mpp';
import {
	ArrowRightOutlined,
	ArrowLeftOutlined,
	DownloadOutlined,
	LoadingOutlined,
} from '@ant-design/icons';
import {
	Button,
	Col,
	Divider,
	Form,
	Input,
	Row,
	Select,
	Table,
	Typography,
} from 'antd';
import dayjs from 'dayjs';
import { FC, Fragment, useState } from 'react';

const DEFAULT_PARAM: FleetSearch = {
	by: '',
	value: '',
};

type MonitoringPlafondAgreementProps = MonitoringPlafondSearchAgreementParam & {
	onBack: () => void;
};
const MonitoringPlafondAgreement: FC<MonitoringPlafondAgreementProps> = ({
	spfId,
	onBack,
}) => {
	const { navigate } = useApp();
	const { form, fieldName } = useForm<FleetSearch>();
	const [param, setParam] = useState<FleetSearch>({
		...DEFAULT_PARAM,
	});

	const searchOptionsQuery = useMonitoringPlafondSearchOptions();
	const searchAgreementQuery = useMonitoringPlafondSearchAgreement({
		spfId,
		search: param,
	});
	const downloadMPPMutation = useDownloadMPP();
	const { data: searchAgreementData } = searchAgreementQuery;
	const { masterAgreements = [] } = searchAgreementData?.data ?? {};
	const { searchByOptions = [] } = searchOptionsQuery.data?.data ?? {};

	// Flatten MPPs from all master agreements
	const flattenedMpps = masterAgreements.flatMap((masterAgreement) =>
		masterAgreement.mpps.map((mpp) => ({
			...mpp,
			masterAgreementId: masterAgreement.masterAgreementId,
			masterAgreementNo: masterAgreement.masterAgreementNo,
			masterAgreementLabel: masterAgreement.label,
		})),
	);

	return (
		<Fragment>
			<div
				style={{
					display: 'flex',
					gap: 10,
					marginBottom: 20,
				}}
			>
				{typeof onBack === 'function' && (
					<div>
						<button
							style={{
								display: 'flex',
								height: 44,
								width: 44,
								fontSize: 24,
								border: 'none',
								alignItems: 'center',
								justifyContent: 'center',
								background: '#1557BC',
								color: 'white',
								cursor: 'pointer',
							}}
							onClick={() => onBack?.()}
						>
							<ArrowLeftOutlined />
						</button>
					</div>
				)}
				<div style={{ flex: 1 }}>
					<FleetTitle style={{ marginBottom: 20 }}>
						Monitoring Plafon Exp
					</FleetTitle>
				</div>
			</div>

			<Form
				{...ANTD_DEFAULT_PROPS.FORM}
				form={form}
				layout="horizontal"
				colon={false}
				labelAlign="left"
				labelCol={{ style: { width: 160 } }}
				style={{ marginBlock: 20 }}
				onFinish={setParam}
			>
				<Row
					gutter={20}
					wrap={false}
				>
					<Col flex="none">
						<Form.Item
							label="Search by"
							name={fieldName('by')}
						>
							<Select
								allowClear
								style={{ width: 200 }}
								options={searchByOptions.map((option: MasterData) => {
									return {
										label: option.value,
										value: option.id,
									};
								})}
								onSelect={() => {
									form.resetFields([fieldName('value')]);
								}}
								onClear={() => {
									form.resetFields([fieldName('by'), fieldName('value')]);
								}}
							/>
						</Form.Item>
					</Col>
					<Col flex="auto">
						<Form.Item
							name={fieldName('value')}
							noStyle
						>
							<Input />
						</Form.Item>
					</Col>
					<Col flex="none">
						<Button
							block
							style={{ width: 200 }}
							type="primary"
							htmlType="submit"
							disabled={searchAgreementQuery.isFetching}
							loading={searchAgreementQuery.isLoading}
						>
							SEARCH
						</Button>
					</Col>
				</Row>
				<Divider />
			</Form>

			<Typography.Title level={3}>
				List Memo Pencairan Pembiayaan
			</Typography.Title>

			<Table
				style={{ marginBlock: 20 }}
				bordered
				scroll={{ x: 'max-content' }}
				loading={searchAgreementQuery.isFetching}
				dataSource={flattenedMpps
					.filter((record) => record.mppId)
					.map((record, key) => {
						return {
							...record,
							key,
						};
					})}
				pagination={false}
				columns={[
					{
						title: 'No',
						align: 'center',
						fixed: 'left',
						width: 1,
						render: (_, __, index) => index + 1,
					},
					{
						title: 'No. MPP',
						render: (_, record) => record.mppNo || '-',
					},
					{
						title: 'No. Kesepakatan Realisasi Pencairan',
						align: 'center',
						render: (_, record) => record.disbursementDocumentNo || '-',
					},
					{
						title: 'Tanggal MPP',
						render: (_, record) => {
							if (!record.mppDate) return '-';
							return dayjs(record.mppDate).format('DD/MM/YYYY');
						},
					},
					{
						title: 'NTF',
						render: () => '-',
					},
					{
						title: 'Approval MPP',
						render: (_, record) => record.mppApprovalStatus || '-',
					},
					{
						title: 'Status MPP',
						render: (_, record) => record.mppStatus || '-',
					},
					{
						title: 'Download MPP',
						align: 'center',
						render: (_, record) => {
							if (!record.mppId) {
								return <DownloadOutlined style={{ color: '#bababa' }} />;
							}

							const isDownloading =
								downloadMPPMutation.isPending &&
								downloadMPPMutation.variables?.mppId === record.mppId &&
								downloadMPPMutation.variables?.spfId === Number(spfId);

							return (
								<a
									href="#"
									onClick={async (e) => {
										e.preventDefault();
										if (downloadMPPMutation.isPending) return;

										try {
											const res = await downloadMPPMutation.mutateAsync({
												mppId: record.mppId,
												spfId: Number(spfId),
											});

											const link = document.createElement('a');
											link.href = res.data.signedUrl;
											document.body.appendChild(link);
											link.click();
											document.body.removeChild(link);
										} catch (error) {
											console.error('Failed to download MPP:', error);
										}
									}}
								>
									{isDownloading ? <LoadingOutlined /> : <DownloadOutlined />}
								</a>
							);
						},
					},
					{
						title: 'View PO',
						fixed: 'right',
						align: 'center',
						render: (_, record) => {
							return (
								<a
									href="#"
									onClick={(e) => {
										e.preventDefault();
										navigate('MonitoringPlafondPO', {
											mppId: record.mppId,
											onBack: () => {
												navigate('MonitoringPlafondAgreement', {
													spfId,
													onBack,
													search: param,
												});
											},
										});
									}}
								>
									<ArrowRightOutlined />
								</a>
							);
						},
					},
				]}
			/>
		</Fragment>
	);
};

export default MonitoringPlafondAgreement;
